<div class="row" *ngIf="!isPreview">
  <div class="clearfix"></div>
  <div class="col-lg-3 float-left">
    <div class="position-sticky-top">
      <div class="sidebar-listing" *ngIf="!displayPalette">
        <div class="top_heading">
          <div class="sidebar-placeholder-title">Placeholders</div>
          <div class="sidebar-accordion-icon-holder">
            <a *ngIf="!showFirstMenu" (click)="showFirstMenu = true;"
              class="pi pi-plus-circle sidebar-accordian-icon"></a>
            <a *ngIf="showFirstMenu" (click)="showFirstMenu = false;"
              class="pi pi-minus-circle sidebar-accordian-icon"></a>
          </div>
        </div>
        <ng-template [ngIf]="showFirstMenu">
          <div class="headingMessage mt-2">
            <span><img class="mr-1" alt="" src="/assets/images/admin_reports_icons/info-grey.png">Click on the list to
              drop
              fields on right section</span>
            <input type="text" placeholder="Search Placeholders" [(ngModel)]="placeHolderFilter" class="form-control">
          </div>
          <ul class="sidebar-one-ul mt-2 mb-2">
            <div class="subHeading">Pre-defined Section</div>
            <li
              *ngFor="let standard of placeHolderStandardArray | vdBuilderFilter:{keyword:placeHolderFilter}; let i = index"
              draggable="true" (dragend)="onDragEnd($event, standard)">
              <div class="placeHolderContainer">
                <div>{{standard.label}}</div>
                <div class="tickSign">&#10004;</div>
              </div>
            </li>
          </ul>
          <hr class="separator">
          <ul class="sidebar-one-ul mt-2 mb-2">
            <div class="subHeading">Custom Section</div>
            <li
              *ngFor="let custom of placeHolderCustomArray | vdBuilderFilter:{keyword:placeHolderFilter}; let i = index"
              cdkDrag draggable="true" (cdkDragEnded)="onDragEnd($event, custom)" class="example-boundary">
              <div class="placeHolderContainer example-box">
                <div>{{custom.label}}</div>
              </div>
            </li>
          </ul>
        </ng-template>
      </div>
      <div *ngIf="displayPalette">
        <div class="sidebar-listing paletteSidebar">
          <div class="top_heading">
            <div class="col-md-12 back">
              <span class="back-icon float-left" (click)="backSetting()">&#10094;</span>
              <span class="float-left palette-heading" (click)="backSetting()"
                title="Settings: {{palette.label}}">Settings:
                {{palette.label}}</span>
              <div class="float-left">
                <a *ngIf="!showFirstMenu" (click)="showFirstMenu = true;"
                  class="pi pi-plus-circle sidebar-accordian-icon"></a>
                <a *ngIf="showFirstMenu" (click)="showFirstMenu = false;"
                  class="pi pi-minus-circle sidebar-accordian-icon"></a>
              </div>
            </div>
          </div>
          <ng-template [ngIf]="showFirstMenu">
            <ul class="nav nav-tabs" style="overflow:hidden; height: auto;">
              <li class="nav-item">
                <a class="nav-link custom-nav-link" [ngClass]="{'activeNav': showTabs == 'general'}"
                  (click)="tabs('general')">General</a>
              </li>
              <li class="nav-item">
                <a class="nav-link custom-nav-link" [ngClass]="{'activeNav': showTabs == 'optional'}"
                  (click)="tabs('optional')">Optional</a>
              </li>
              <li class="nav-item">
                <a class="nav-link custom-nav-link" [ngClass]="{'activeNav': showTabs == 'advanced'}"
                  (click)="tabs('advanced')">Advanced</a>
              </li>
            </ul>
            <div class="scrollTabContent">
              <div class="tab-content"
                *ngIf="palette.layoutCode !== 'CustomChipComponent' && palette.layoutCode !== 'CustomQuestionsGroupComponent' && palette.layoutCode !== 'VdAddGenerateFormComponent' && palette.layoutCode !== 'CustomRadioButtonComponent'  && palette.layoutCode !== 'CustomFormRadioButtonComponent' && palette.layoutCode !== 'CustomCheckboxComponent' && palette.layoutCode !== 'CustomGridEditor' && palette.layoutCode !== 'CustomCheckboxComponent'  && palette.layoutCode !== 'CustomButtonComponent'  && palette.layoutCode !== 'CustomButtonActionComponent'">
                <div class="tab-pane container active" id="general" *ngIf="showTabs == 'general'">
                  <div class="p-fluid p-formgrid p-grid pt-2"
                    *ngIf="palette.layoutCode !== 'VdSwitchGroupComponent' && palette.layoutCode !== 'VdDividerComponent' && palette.layoutCode !== 'VdLabelComponent' && palette.layoutCode !== 'VdCountComponent'">
                    <div class="p-col-11 marginBtmLeft" *ngIf="palette.layoutCode !== 'VdTextAreaComponent'">
                      <label class="label-cls mb-1">Label Name</label>
                      <input type="text" [placeholder]="palette.label" #label name="label"
                        [(ngModel)]="palette.label" />
                      <div class="indicatorRef">Label of the field</div>
                    </div>
                    <div class="p-col-11 marginBtmLeft" *ngIf="palette.layoutCode === 'VdTextAreaComponent'">
                      <label class="label-cls mb-1">Label Name</label>
                      <input type="text" [placeholder]="palette.properties.textArealabel" #textArealabel
                        name="textArealabel" [(ngModel)]="palette.properties.textArealabel" />
                      <div class="indicatorRef">Label of the field</div>
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Sub Label</label>
                      <input type="text" class="form-control" [placeholder]="palette.subText" #sublabel name="sublabel"
                        [(ngModel)]="palette.subText" />
                      <div class="indicatorRef">Add small description below the input field</div>
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Align to</label>
                      <div class="clearfix"></div>
                      <div class="vd-radio-container">
                        <input type="radio" class="radio" name="align" value="top" id="top"
                          (change)="palette.align = 'top'" [checked]="palette.align == 'top'" />
                        <label for="top" class="label-cls mb-1">Top</label>
                        <input type="radio" class="radio" name="align" value="left" id="left"
                          (change)="palette.align = 'left'" [checked]="palette.align == 'left'" />
                        <label for="left" class="label-cls mb-1">Left</label>
                      </div>
                      <div class="clearfix"></div>
                      <div class="indicatorRef">Select how the label is placed</div>
                    </div>
                    <div class="clearfix"></div>
                    <div class="p-col-11 marginBtmLeft">
                      <p-inputSwitch id="requiredValidation" [(ngModel)]="palette.mandatory"
                        (onChange)="requiredValidation($event)"></p-inputSwitch>
                      <div class="indicatorRef">Prevent submission, if the field is empty</div>
                    </div>
                  </div>
                  <div class="p-fluid p-formgrid p-grid pt-2" *ngIf="palette.layoutCode === 'VdSwitchGroupComponent'">
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Label Name</label>
                      <input type="text" [placeholder]="palette?.groupElementProperty?.questionLabel" #questionLabel
                        name="questionLabel" [(ngModel)]="palette.groupElementProperty.questionLabel" />
                      <div class="indicatorRef">Label of the field</div>
                    </div>
                    <!--Is twostate-->
                    <div class="p-col-11 marginBtmLeft">
                      <!-- <label class="label-cls mb-1">Is this a two-state field?</label> -->
                      <!-- <div style="display: flex; "> -->
                        <input type="checkbox" [(ngModel)]="palette.groupElementProperty.isTwostate"
                          style="width:20px; height:20px; float:left" />
                        <span style="float:left; margin-left:10px">Is this a two-state field?</span>
                      <!-- </div> -->
                      <!-- <div class="row" *ngIf="palette.groupElementProperty.isTristate">
                        <div class="p-col-11 marginBtmLeft">
                          <label class="label-cls mb-1">Label for ON</label>
                          <div style="display: flex; ">
                            <input type="text" class="form-control"
                            [(ngModel)]="palette.groupElementProperty.options[0].label" />
                          </div>
                        </div>
                        <div class="p-col-11 marginBtmLeft">
                          <label class="label-cls mb-1">Label for N/A</label>
                          <div style="display: flex; ">
                            <input type="text" class="form-control"
                            [(ngModel)]="palette.groupElementProperty.options[1].label" />
                          </div>
                        </div>
                        <div class="p-col-11 marginBtmLeft">
                          <label class="label-cls mb-1">Label for OFF</label>
                          <div style="display: flex; ">
                            <input type="text" class="form-control"
                            [(ngModel)]="palette.groupElementProperty.options[2].label" />
                          </div>
                        </div>
                      </div> -->
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Text Area Label</label>
                      <input type="text" class="form-control"
                        [placeholder]="palette?.groupElementProperty?.textAreaLabel" #textAreaLabel name="textAreaLabel"
                        [(ngModel)]="palette.groupElementProperty.textAreaLabel" />
                      <div class="indicatorRef">Label of the Text Area</div>
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Sub Label</label>
                      <input type="text" class="form-control" [placeholder]="palette?.subText" #sublabel name="sublabel"
                        [(ngModel)]="palette.subText" />
                      <div class="indicatorRef">Add small description below the input field</div>
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Label Width</label>
                      <input type="text" #labelStyleWidth name="labelStyleWidth"
                        [(ngModel)]="palette.groupElementProperty.labelStyle.width" />
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Text Area Width</label>
                      <input type="text" #textAreaWidth name="textAreaWidth"
                        [(ngModel)]="palette.groupElementProperty.textAreaStyle.width" />
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Show Text Area when switch is </label>
                      <select type="text" class="form-control" #whenTextAreaShown name="whenTextAreaShown"
                        [(ngModel)]="palette.groupElementProperty.whenTextAreaShown">
                        <option value="on">On</option>
                        <option value="off">Off</option>
                        <option value="both">Both</option>
                      </select>
                    </div>
                    <!-- <div class="p-col-11 marginBtmLeft">
                                  <label class="label-cls mb-1">Label Align to</label>
                                  <div class="clearfix"></div>
                                  <div class="vd-radio-container">
                                      <input type="radio" class="radio" name="align" value="top" id="top" (change)="palette.align = 'top'" [checked]="palette.align == 'top'" />
                                      <label for="top" class="label-cls mb-1">Top</label>
                                      <input type="radio" class="radio" name="align" value="left" id="left" (change)="palette.align = 'left'" [checked]="palette.align == 'left'" />
                                      <label for="left" class="label-cls mb-1">Left</label>
                                  </div>
                                  <div class="clearfix"></div>
                                  <div class="indicatorRef">Select how the label is placed</div>
                              </div> -->
                    <div class="clearfix"></div>
                    <div class="p-col-11 marginBtmLeft">
                      <p-inputSwitch id="requiredValidation" [(ngModel)]="palette.mandatory"
                        (onChange)="requiredValidation($event)"></p-inputSwitch>
                      <div class="indicatorRef">Prevent submission, if the field is empty</div>
                    </div>
                  </div>
                  <div class="p-fluid p-formgrid p-grid pt-2" *ngIf="palette.layoutCode === 'VdCountryStateComponent'">
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Country Width</label>
                      <input type="text" #countryStyleWidth name="countryStyleWidth"
                        [(ngModel)]="palette.groupElementProperty.countryStyle.width" />
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">State Width</label>
                      <input type="text" #stateListWidth name="stateListWidth"
                        [(ngModel)]="palette.groupElementProperty.stateStyle.width" />
                    </div>
                  </div>
                  <div class="p-fluid p-formgrid p-grid pt-2" *ngIf="palette.layoutCode === 'VdDividerComponent'">
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1"> Width</label>
                      <input type="text" #dividerWidth name="dividerWidth" [(ngModel)]="palette.style.width" />
                    </div>
                    <div class="clearfix"></div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Color</label>
                      <input type="color" id="favcolor" name="favcolor" [value]="palette.style.borderColor"
                        [(ngModel)]="palette.style.borderColor"><br><br>
                      <!-- <input type="text" #dividerWidth name="dividerWidth" [(ngModel)]="palette.style.width" /> -->
                    </div>
                    <div class="clearfix"></div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Divider Type</label>
                      <select type="text" class="form-control" #dividerType name="dividerType"
                        [(ngModel)]="palette.style.borderStyle">
                        <option>Select</option>
                        <option value="dashed">Dashed</option>
                        <option value="solid">Solid</option>
                        <option value="dotted">Dotted</option>
                      </select>
                      <div class="indicatorRef">Type of divider line</div>
                    </div>
                  </div>
                  <div class="p-fluid p-formgrid p-grid pt-2" *ngIf="palette.layoutCode === 'VdLabelComponent'">
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Title</label>
                      <input type="text" [placeholder]="palette.properties.title" #title name="title"
                        [(ngModel)]="palette.properties.title" />
                      <div class="indicatorRef">Enter the text/ content </div>
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Color</label>
                      <input type="color" id="favcolor" name="favcolor" [value]="palette.style.color"
                        [(ngModel)]="palette.style.color"><br><br>
                      <!-- <input type="text" #dividerWidth name="dividerWidth" [(ngModel)]="palette.style.width" /> -->
                    </div>
                    <div class="clearfix"></div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Font Weight</label>
                      <select type="text" class="form-control" #fontWeight name="fontWeight"
                        [(ngModel)]="palette.style.fontWeight">
                        <option>Select</option>
                        <option value="bold">Bold</option>
                        <option value="normal">Normal</option>
                        <option value="bolder">Bolder</option>
                        <option value="lighter">Lighter</option>
                      </select>
                      <div class="indicatorRef">Font Weight</div>
                    </div>
                  </div>

                  <div class="p-fluid p-formgrid p-grid pt-2" *ngIf="palette.layoutCode === 'VdCountComponent'">
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Staff Count Label</label>
                      <input type="text" [placeholder]="palette.properties.label" #title name="title"
                        [(ngModel)]="palette.properties.label" />
                      <div class="indicatorRef"> </div>
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Count</label>
                      <input type="text" [placeholder]="palette.properties.count" #title name="title"
                        [(ngModel)]="palette.properties.count" />
                      <div class="indicatorRef">Enter the Count </div>
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Color</label>
                      <input type="color" id="favcolor" name="favcolor" [value]="palette.style.color"
                        [(ngModel)]="palette.style.color"><br><br>
                      <!-- <input type="text" #dividerWidth name="dividerWidth" [(ngModel)]="palette.style.width" /> -->
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Background Color</label>
                      <input type="color" id="favcolor" name="favcolor" [value]="palette.style.backgroundColor"
                        [(ngModel)]="palette.style.backgroundColor"><br><br>
                    </div>
                    <div class="p-col-11 marginBtmLeft" *ngIf="palette.style">
                      <label class="label-cls mb-1">Width of the field</label>
                      <input type="text" #width name="width" [(ngModel)]="palette.style.width" />
                    </div>
                    <div class="clearfix"></div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Font Weight</label>
                      <select type="text" class="form-control" #fontWeight name="fontWeight" [(ngModel)]="palette.style.fontWeight">
                        <option>Select</option>
                        <option value="bold">Bold</option>
                        <option value="normal">Normal</option>
                        <option value="bolder">Bolder</option>
                        <option value="lighter">Lighter</option>
                      </select>
                      <div class="indicatorRef">Font Weight</div>
                    </div>
                  </div>

                </div>
                <div class="tab-pane container active" id="optional" *ngIf="showTabs == 'optional'">
                  <div class="p-fluid p-formgrid p-grid pt-2">
                    <!-- <div class="p-col-11 marginBtmLeft">
                                  <label class="label-cls mb-1">Width</label>
                                  <div class="clearfix"></div>
                                  <div class="vd-radio-container">
                                      <input type="radio" class="radio" id="fixed" name="widthType" value="fixed"  [attr.checked]="palette.style.width !== 'auto'" />
                                      <label for="fixed" class="label-cls mb-1">Fixed</label>
                                      <input type="radio" class="radio" id="auto" name="widthType" value="auto"  [attr.checked]="palette.style.width ==='auto'" />
                                      <label for="auto" class="label-cls mb-1">Auto</label>
                                  </div>
                                  <div class="clearfix"></div>
                                  <div class="indicatorRef">The width of this field will change accordingly to your form's width</div>
                              </div> -->
                    <div class="p-col-11 marginBtmLeft" *ngIf="palette.style">
                      <label class="label-cls mb-1">Width of the field</label>
                      <input type="text" #width name="width" [(ngModel)]="palette.style.width" />
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Field Validation</label>
                      <select type="text" class="form-control" #validation name="validation">
                        <option>Select</option>
                      </select>
                      <div class="indicatorRef">Check if the entry matches the selected format</div>
                    </div>
                    <!-- <div class="p-col-11 marginBtmLeft">
                                  <div class="indicatorRef">Character Limit</div>
                                  <p-inputSwitch id="requiredValidation" formControlName="requiredValidation"
                                  (onChange)="requiredValidation($event)"></p-inputSwitch>
                              </div> -->
                    <div class="p-col-12 marginBtmLeft">
                      <div class="p-col-6 float-left">
                        <label class="label-cls mb-1">Min. character</label>
                        <input type="text" class="form-control" #minLength name="minLength"
                          [(ngModel)]="palette.minLength" />
                      </div>
                      <div class="p-col-6 float-right">
                        <label class="label-cls mb-1">Max. character</label>
                        <input type="text" class="form-control" #maxLength name="maxLength"
                          [(ngModel)]="palette.maxLength" />
                      </div>
                      <div class="indicatorRef">Limit the number of character allowed for this</div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane container active" id="advanced" *ngIf="showTabs == 'advanced'">
                  <div class="p-fluid p-formgrid p-grid pt-2">
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Placeholder</label>
                      <input type="text" #placeholder name="placeholder" [(ngModel)]="palette.placeholder" />
                      <div class="indicatorRef">Add an example hint inside the field</div>
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Unique Name</label>
                      <input type="text" #uniqueName name="uniqueName" [(ngModel)]="palette.name" />
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Data Field Name</label>
                      <input type="text" #dfName name="datafieldName" [(ngModel)]="palette.data_field_name" />
                    </div>
                    <div class="p-col-11 marginBtmLeft" *ngIf="palette?.properties?.showDataSelection">
                      <label class="label-cls mb-1"> Options to select from </label>
                      <div>
                        <div class="col-4">
                          <p-radioButton name="groupname" [value]="false" label="Options"
                            [(ngModel)]="palette.properties.isDataFromApi">
                          </p-radioButton>
                        </div>
                        <div class="col">
                          <p-radioButton name="groupname" [value]="true" label="Predefined Options"
                            [(ngModel)]="palette.properties.isDataFromApi">
                          </p-radioButton>
                        </div>
                      </div>
                    </div>
                    <div class="p-col-11 marginBtmLeft" *ngIf="palette?.properties?.isDataFromApi">
                      <label class="label-cls mb-1"> Select the Data Source</label>
                      <select type="text" class="form-control" [(ngModel)]="palette.properties.refercenceCodeForApiCall"
                        #refercenceCodeForApiCall name="refercenceCodeForApiCall">
                        <option *ngFor="let item of dataSources" [value]="item.groupName">{{item.groupDesc}}</option>
                      </select>
                    </div>
                    <div class="p-col-11 marginBtmLeft" *ngIf="palette?.properties?.isDocumentTypeDropdown">
                      <label class="label-cls mb-1"> Select the Data Source</label>
                      <select type="text" class="form-control" [(ngModel)]="palette.properties.refercenceCodeForApiCall"
                        #refercenceCodeForApiCall name="refercenceCodeForApiCall">
                        <option *ngFor="let item of listDocumentReferenceData" [value]="item.groupName">
                          {{item.groupDesc}}
                        </option>
                      </select>
                    </div>
                    <div class="p-col-11 marginBtmLeft" *ngIf="palette?.properties?.showSyncButton">
                      <div class="indicatorRef">Enable Sync Button</div>
                      <p-inputSwitch id="isMultiselect" [(ngModel)]="palette.properties.enableSyncButton"
                        (onChange)="handleIsMultiselectChange($event)"></p-inputSwitch>
                      <!-- <div class="indicatorRef">Enable Sync Button</div> -->
                    </div>
                     <!--Dependency for Dropdowns-->
                     <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1"> Select the Data Dependency<small>(Optional)</small></label>
                      <input type="text" class="form-control" [(ngModel)]="palette.properties.dependency"
                        placeholder="Unique name of dependent field">
                  </div>
                   <!-- EO Dependency for Dropdowns-->
                    <div class="p-col-11 marginBtmLeft"
                      *ngIf="!palette?.properties?.isDataFromApi && palette?.properties?.inputArray">
                      <label class="label-cls mb-1"> Options</label>
                      <p-chips class="vd-chip" separator=","  name="inputArray" [(ngModel)]="palette.properties.inputArray">
                      </p-chips>
                      <div class="indicatorRef">Please enter comma separated values</div>
                    </div>
                    <div class="p-col-11 marginBtmLeft" *ngIf="palette?.properties?.showMultiSelectOption">
                      <div class="indicatorRef">Multiple Selections</div>
                      <p-inputSwitch id="isMultiselect" [(ngModel)]="palette.properties.isMultiselect"
                        (onChange)="handleIsMultiselectChange($event)"></p-inputSwitch>
                      <div class="indicatorRef">Allow users to select multiple options.</div>
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <select type="text" class="form-control" #validation name="validation">
                        <option>Rule for the field</option>
                      </select>
                    </div>
                    <!-- This setting is applicable for  CustomTextFieldComponent-->
                    <div class="p-col-11 marginBtmLeft" style="margin-top:8px"
                      *ngIf="palette.layoutCode == 'CustomTextFieldComponent'">
                      <div style="display: flex; ">
                        <input type="checkbox" [(ngModel)]="palette.isChecked"
                          style="width:20px; height:20px; float:left" />
                        <span style="float:left; margin-left:10px">Hide/Show Checkbox Setting</span>
                      </div>
                      <input type="type" [(ngModel)]="palette.checkboxLabel" placeholder="Add checkbox label" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-content" *ngIf="palette.layoutCode == 'CustomQuestionsGroupComponent'">
                <div class="tab-pane container active" id="general" *ngIf="showTabs == 'general'">
                  <div class="p-fluid p-formgrid p-grid pt-2">
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Label Name</label>
                      <input type="text" [placeholder]="palette.label" #label name="label"
                        [(ngModel)]="palette.label" />
                      <div class="indicatorRef">Label of the field</div>
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <div style="display: flex; ">
                        <input type="checkbox" [(ngModel)]="palette.isTwostate"
                          style="width:20px; height:20px; float:left" />
                        <span style="float:left; margin-left:10px">Is this a two-state field?</span>
                      </div>
                    </div>
                    <div class="p-col-11 marginBtmLeft" *ngIf="palette.style">
                      <label class="label-cls mb-1">Width of the field</label>
                      <input type="text" #width name="width" [(ngModel)]="palette.style.width" />
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Unique Name</label>
                      <input type="text" #uniqueName name="uniqueName" [(ngModel)]="palette.name" />
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Data Field Name</label>
                      <input type="text" #dfName name="datafieldName" [(ngModel)]="palette.data_field_name" />
                    </div>
                  </div>
                </div>
                <div class="tab-pane container active" id="optional" *ngIf="showTabs == 'optional'">
                </div>
                <div class="tab-pane container active" id="advanced" *ngIf="showTabs == 'advanced'">
                </div>
              </div>
              <div class="tab-content" *ngIf="palette.layoutCode == 'VdAddGenerateFormComponent'">
                <div class="tab-pane container active" id="general" *ngIf="showTabs == 'general'">
                  <div class="p-fluid p-formgrid p-grid pt-2">
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Select Form</label>
                      <p-multiSelect [style]="{width: '250px'}" optionValue="formType" [options]="formTypeList"
                        [(ngModel)]="palette.properties.selectedFormTypes" defaultLabel="Select Visa"
                        optionLabel="displayName">
                      </p-multiSelect>
                    </div>
                    <!-- {{palette.properties.formTypeArray[0]}} -->
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Form Applicable to</label><br />
                      <p-checkbox class="ml-2" binary="false" name="includeBeneficiary"
                        [(ngModel)]="palette.properties.formIncludeBeneficiary"
                        inputId="includeBeneficiary"></p-checkbox>
                      <label class="label-cls mt-1 ml-1">Include Beneficiary</label>
                    </div>
                    <!-- <div class="p-col-11 marginBtmLeft">
                                  <label class="label-cls mb-1">Unique Name</label>
                                  <input type="text" #uniqueName name="uniqueName" [(ngModel)]="palette.name" />
                              </div>  -->
                  </div>
                </div>
                <div class="tab-pane container active" id="optional" *ngIf="showTabs == 'optional'">
                </div>
                <div class="tab-pane container active" id="advanced" *ngIf="showTabs == 'advanced'">
                </div>
              </div>
              <div class="tab-content" *ngIf="(palette.layoutCode === 'CustomRadioButtonComponent') || (palette.layoutCode === 'CustomFormRadioButtonComponent')">
                <div class="tab-pane container active" id="general" *ngIf="showTabs == 'general'">
                  <div class="p-fluid p-formgrid p-grid pt-2">
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Label Name</label>
                      <input type="text" [placeholder]="palette.label" #label name="label"
                        [(ngModel)]="palette.label" />
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Align to</label>
                      <div class="clearfix"></div>
                      <div class="vd-radio-container">
                        <input type="radio" class="radio" name="align" value="top" id="top"
                          (change)="palette.align = 'top'" [checked]="palette.align == 'top'" />
                        <label for="top" class="label-cls mb-1">Top</label>
                        <input type="radio" class="radio" name="align" value="left" id="left"
                          (change)="palette.align = 'left'" [checked]="palette.align == 'left'" />
                        <label for="left" class="label-cls mb-1">Left</label>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                    <div class="p-col-11 marginBtmLeft">
                      <p-inputSwitch id="requiredValidation" [(ngModel)]="palette.mandatory"
                        (onChange)="requiredValidation($event)"></p-inputSwitch>
                      <div class="indicatorRef">Mandatory</div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane container active" id="optional" *ngIf="showTabs == 'optional'">
                  <div class="p-fluid p-formgrid p-grid pt-2">
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Width</label>
                      <div class="clearfix"></div>
                      <div class="vd-radio-container">
                        <input type="radio" class="radio" name="align" value="top" id="top"
                          (change)="palette.align = 'top'" [attr.checked]="palette.align == 'top'" />
                        <label for="top" class="label-cls mb-1">Fixed</label>
                        <input type="radio" class="radio" name="align" value="left" id="left"
                          (change)="palette.align = 'left'" [attr.checked]="palette.align == 'left'" />
                        <label for="left" class="label-cls mb-1">Auto</label>
                      </div>
                      <div class="clearfix"></div>
                      <div class="indicatorRef">The width of this field will change accordingly to your form's width
                      </div>
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Width of the field</label>
                      <input type="text" #width name="width" [(ngModel)]="palette.style.width" />
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Field Validation</label>
                      <select type="text" class="form-control" #validation name="validation">
                        <option>Select</option>
                      </select>
                      <div class="indicatorRef">Check if the entry matches the selected format</div>
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <div class="indicatorRef">Character Limit</div>
                      <p-inputSwitch id="requiredValidation" formControlName="requiredValidation"
                        (onChange)="requiredValidation($event)"></p-inputSwitch>
                    </div>
                    <div class="p-col-12 marginBtmLeft">
                      <div class="p-col-6 float-left">
                        <label class="label-cls mb-1">Min. character</label>
                        <input type="text" class="form-control" #minLength name="minLength"
                          [(ngModel)]="palette.minLength" />
                      </div>
                      <div class="p-col-6 float-right">
                        <label class="label-cls mb-1">Max. character</label>
                        <input type="text" class="form-control" #maxLength name="maxLength"
                          [(ngModel)]="palette.maxLength" />
                      </div>
                      <div class="indicatorRef">Limit the number of character allowed for this</div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane container active" id="advanced" *ngIf="showTabs == 'advanced'">
                  <div class="p-fluid p-formgrid p-grid pt-2">
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Placeholder</label>
                      <input type="text" #placeholder name="placeholder" [(ngModel)]="palette.placeholder" />
                      <div class="indicatorRef">Add an example hint inside the field</div>
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Hover Text</label>
                      <input type="text" #hoverText name="hoverTest" [(ngModel)]="palette.hoverText" />
                      <div class="indicatorRef">Show a description of this field when hovered</div>
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Default Value</label>
                      <input type="text" #defaultValue name="defaultValue" [(ngModel)]="palette.defaultValue" />
                      <div class="indicatorRef">Pre populate a value for this field</div>
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <div class="indicatorRef">Read Only</div>
                      <p-inputSwitch id="readOnly" [(ngModel)]="palette.readonly"
                        (onChange)="handleReadonlySwitch($event)">
                      </p-inputSwitch>
                      <div class="indicatorRef">Prevent entry to this field</div>
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <div class="indicatorRef">Hide Field</div>
                      <p-inputSwitch id="hideField" formControlName="hideField" (onChange)="hideField($event)">
                      </p-inputSwitch>
                      <div class="indicatorRef">Hide Field</div>
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Unique Name</label>
                      <input type="text" #uniqueName name="uniqueName" [(ngModel)]="palette.name" />
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Data Field Name</label>
                      <input type="text" #dfName name="datafieldName" [(ngModel)]="palette.data_field_name" />
                    </div>
                    <div class="p-col-11 marginBtmLeft" *ngIf="palette?.properties?.showDataSelection">
                      <label class="label-cls mb-1"> Options to select from </label>
                      <div>
                        <div class="col-4">
                          <p-radioButton name="groupname" [value]="false" label="Options"
                            [(ngModel)]="palette.properties.isDataFromApi" (onClick)="onChangeOfOption(palette)">
                          </p-radioButton>
                        </div>
                        <div class="col">
                          <p-radioButton name="groupname" [value]="true" label="Predefined Options"
                            [(ngModel)]="palette.properties.isDataFromApi" (onClick)="onChangeOfOption(palette)">
                          </p-radioButton>
                        </div>
                      </div>
                    </div>
                    <div class="p-col-11 marginBtmLeft" *ngIf="palette?.properties?.isDataFromApi">
                      <label class="label-cls mb-1"> Select the Data Source</label>
                      <select type="text" class="form-control" [(ngModel)]="palette.properties.refercenceCodeForApiCall"
                        #refercenceCodeForApiCall name="refercenceCodeForApiCall">
                        <option *ngFor="let item of dataSources" [value]="item.groupName">{{item.groupDesc}}</option>
                      </select>
                    </div>
                    <div class="p-col-11 marginBtmLeft" *ngIf="!palette?.properties?.isDataFromApi">
                      <label class="label-cls mb-1"> Options </label>
                      <div class="options-list-view">
                        <div class="options-list-items clearfix" *ngFor="let item of palette.value; let i = index;">
                          <span class="options-list-items-text" [ngClass]="{'d-none': item.isEdit}">{{
                            item.name }}</span>
                          <textarea rows="1" cols="30" [(ngModel)]="item.name" class="options-list-items-textarea"
                            pInputTextarea autoResize="autoResize" [ngClass]="{'d-none': !item.isEdit}"></textarea>
                          <!-- <input type="text" class="options-list-items-input" [ngClass]="{'d-none': !item.isEdit}"
                        [(ngModel)]="item.name" pInputText /> -->
                          <a class="options-list-items-edit pi pi-save"
                            [ngClass]="{'d-none': !item.isEdit, 'disabled': !item.name || (item.name && item.name.trim().length === 0)}"
                            (click)="item.name && item.name.trim().length > 0 && item.isEdit = false;"></a>
                          <a class="options-list-items-edit pi pi-times-circle" (click)="onOptionItemEditClose(item)"
                            [ngClass]="{'d-none': !item.isEdit}" (click)="item.isEdit = false;"></a>
                          <a *ngIf="palette.layoutCode === 'CustomFormRadioButtonComponent' && item.code && !palette.properties.isDataFromApi" class="options-list-items-edit pi pi-upload" [ngClass]="{'d-none': item.isEdit}"
                            (click)="uploadIconImage(item)"></a>
                          <a class="options-list-items-edit pi pi-pencil" [ngClass]="{'d-none': item.isEdit}"
                            (click)="onOptionItemEdit(item)"></a>
                          <a class="options-list-items-delete pi pi-trash" [ngClass]="{'d-none': item.isEdit}"
                            (click)="onOptionItemDelete(i)"></a>
                        </div>
                        <div class="options-list-items-add-container clearfix">
                          <textarea rows="1" cols="30" [(ngModel)]="newOption" class="options-list-items-add-textarea"
                            pInputTextarea autoResize="autoResize"></textarea>
                          <!-- <input type="text" class="options-list-items-add-input" [(ngModel)]="newOption" pInputText /> -->
                          <a class="options-list-items-add pi pi-plus"
                            [ngClass]="{'disabled': !newOption || (newOption && newOption.trim().length === 0)}"
                            (click)="newOption && newOption.trim().length > 0 && addOptionItem()"></a>
                        </div>
                      </div>
                      <!-- <p-chips separator="," name="inputArray" [(ngModel)]="palette.properties.inputArray">
                  </p-chips>
                  <div class="indicatorRef">Please enter comma separated values</div> -->
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <select type="text" class="form-control" #validation name="validation">
                        <option>Rule for the field</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-content" *ngIf="palette.layoutCode === 'CustomCheckboxComponent'">
                <div class="tab-pane container active" id="general" *ngIf="showTabs == 'general'">
                  <div class="p-fluid p-formgrid p-grid pt-2">
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Label Name</label>
                      <input type="text" [placeholder]="palette.label" #label name="label"
                        [(ngModel)]="palette.label" />
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Align to</label>
                      <div class="clearfix"></div>
                      <div class="vd-radio-container">
                        <input type="radio" class="radio" name="align" value="top" id="top"
                          (change)="palette.align = 'top'" [checked]="palette.align == 'top'" />
                        <label for="top" class="label-cls mb-1">Top</label>
                        <input type="radio" class="radio" name="align" value="left" id="left"
                          (change)="palette.align = 'left'" [checked]="palette.align == 'left'" />
                        <label for="left" class="label-cls mb-1">Left</label>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                    <div class="p-col-11 marginBtmLeft">
                      <p-inputSwitch id="requiredValidation" [(ngModel)]="palette.mandatory"
                        (onChange)="requiredValidation($event)"></p-inputSwitch>
                      <div class="indicatorRef">Mandatory</div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane container active" id="optional" *ngIf="showTabs == 'optional'">
                  <div class="p-fluid p-formgrid p-grid pt-2">
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Width</label>
                      <div class="clearfix"></div>
                      <div class="vd-radio-container">
                        <input type="radio" class="radio" name="align" value="top" id="top"
                          (change)="palette.align = 'top'" [attr.checked]="palette.align == 'top'" />
                        <label for="top" class="label-cls mb-1">Fixed</label>
                        <input type="radio" class="radio" name="align" value="left" id="left"
                          (change)="palette.align = 'left'" [attr.checked]="palette.align == 'left'" />
                        <label for="left" class="label-cls mb-1">Auto</label>
                      </div>
                      <div class="clearfix"></div>
                      <div class="indicatorRef">The width of this field will change accordingly to your form's width
                      </div>
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Width of the field</label>
                      <input type="text" #width name="width" [(ngModel)]="palette.style.width" />
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Field Validation</label>
                      <select type="text" class="form-control" #validation name="validation">
                        <option>Select</option>
                      </select>
                      <div class="indicatorRef">Check if the entry matches the selected format</div>
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <div class="indicatorRef">Character Limit</div>
                      <p-inputSwitch id="requiredValidation" formControlName="requiredValidation"
                        (onChange)="requiredValidation($event)"></p-inputSwitch>
                    </div>
                    <div class="p-col-12 marginBtmLeft">
                      <div class="p-col-6 float-left">
                        <label class="label-cls mb-1">Min. character</label>
                        <input type="text" class="form-control" #minLength name="minLength"
                          [(ngModel)]="palette.minLength" />
                      </div>
                      <div class="p-col-6 float-right">
                        <label class="label-cls mb-1">Max. character</label>
                        <input type="text" class="form-control" #maxLength name="maxLength"
                          [(ngModel)]="palette.maxLength" />
                      </div>
                      <div class="indicatorRef">Limit the number of character allowed for this</div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane container active" id="advanced" *ngIf="showTabs == 'advanced'">
                  <div class="p-fluid p-formgrid p-grid pt-2">
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Placeholder</label>
                      <input type="text" #placeholder name="placeholder" [(ngModel)]="palette.placeholder" />
                      <div class="indicatorRef">Add an example hint inside the field</div>
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Hover Text</label>
                      <input type="text" #hoverText name="hoverTest" [(ngModel)]="palette.hoverText" />
                      <div class="indicatorRef">Show a description of this field when hovered</div>
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Default Value</label>
                      <input type="text" #defaultValue name="defaultValue" [(ngModel)]="palette.defaultValue" />
                      <div class="indicatorRef">Pre populate a value for this field</div>
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <div class="indicatorRef">Read Only</div>
                      <p-inputSwitch id="readOnly" [(ngModel)]="palette.readonly"
                        (onChange)="handleReadonlySwitch($event)">
                      </p-inputSwitch>
                      <div class="indicatorRef">Prevent entry to this field</div>
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <div class="indicatorRef">Hide Field</div>
                      <p-inputSwitch id="hideField" formControlName="hideField" (onChange)="hideField($event)">
                      </p-inputSwitch>
                      <div class="indicatorRef">Hide Field</div>
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Unique Name</label>
                      <input type="text" #uniqueName name="uniqueName" [(ngModel)]="palette.name" />
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Data Field Name</label>
                      <input type="text" #dfName name="datafieldName" [(ngModel)]="palette.data_field_name" />
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1"> Options to select from </label>
                      <div>
                        <div class="col-4">
                          <p-radioButton name="groupname" [value]="false" label="Options"
                            [(ngModel)]="palette.properties.isDataFromApi" (onClick)="onChangeOfOption(palette)">
                          </p-radioButton>
                        </div>
                        <div class="col">
                          <p-radioButton name="groupname" [value]="true" label="Predefined Options"
                            [(ngModel)]="palette.properties.isDataFromApi" (onClick)="onChangeOfOption(palette)">
                          </p-radioButton>
                        </div>
                      </div>
                    </div>
                    <div class="p-col-11 marginBtmLeft" *ngIf="palette?.properties?.isDataFromApi">
                      <label class="label-cls mb-1"> Select the Data Source</label>
                      <select type="text" class="form-control" [(ngModel)]="palette.properties.refercenceCodeForApiCall"
                        #refercenceCodeForApiCall name="refercenceCodeForApiCall">
                        <option *ngFor="let item of dataSources" [value]="item.groupName">{{item.groupDesc}}</option>
                      </select>
                    </div>
                    <!-- CHECKBOXES CHIP COMPONENT -->
                    <div class="p-col-11 marginBtmLeft" *ngIf="!palette?.properties?.isDataFromApi">
                      <label class="label-cls mb-1">Options</label>
                      <div class="options-list-view">
                        <div class="options-list-items clearfix" *ngFor="let item of palette.value; let i = index;">
                          <span class="options-list-items-text" [ngClass]="{'d-none': item.isEdit}">{{
                            item.name }}</span>
                          <textarea rows="1" cols="30" [(ngModel)]="item.name" class="options-list-items-textarea"
                            pInputTextarea autoResize="autoResize" [ngClass]="{'d-none': !item.isEdit}"></textarea>
                          <!-- <input type="text" class="options-list-items-input" [ngClass]="{'d-none': !item.isEdit}"
                        [(ngModel)]="item.name" pInputText /> -->
                          <a class="options-list-items-edit pi pi-save"
                            [ngClass]="{'d-none': !item.isEdit, 'disabled': !item.name || (item.name && item.name.trim().length === 0)}"
                            (click)="item.name && item.name.trim().length > 0 && item.isEdit = false;"></a>
                          <a class="options-list-items-edit pi pi-times-circle" (click)="onOptionItemEditClose(item)"
                            [ngClass]="{'d-none': !item.isEdit}" (click)="item.isEdit = false;"></a>
                          <a class="options-list-items-edit pi pi-pencil" [ngClass]="{'d-none': item.isEdit}"
                            (click)="onOptionItemEdit(item)"></a>
                          <a class="options-list-items-delete pi pi-trash" [ngClass]="{'d-none': item.isEdit}"
                            (click)="onOptionItemDelete(i)"></a>
                        </div>
                        <div class="options-list-items-add-container clearfix">
                          <textarea rows="1" cols="30" [(ngModel)]="newOption" class="options-list-items-add-textarea"
                            pInputTextarea autoResize="autoResize"></textarea>
                          <!-- <input type="text" class="options-list-items-add-input" [(ngModel)]="newOption" pInputText /> -->
                          <a class="options-list-items-add pi pi-plus"
                            [ngClass]="{'disabled': !newOption || (newOption && newOption.trim().length === 0)}"
                            (click)="newOption && newOption.trim().length > 0 && addOptionItem()"></a>
                        </div>
                      </div>
                      <!-- <p-chips [(ngModel)]="palette.value" (onAdd)="onKeyDown($event)" (onRemove)="removeChip($event)">
                    <ng-template let-item pTemplate="item">
                      {{item.name}}
                    </ng-template>
                  </p-chips>
                  <div class="indicatorRef">Please enter comma separated values</div> -->
                    </div>
                    <!-- CHECKBOXES CHIP COMPONENT -->
                    <div class="p-col-11 marginBtmLeft">
                      <select type="text" class="form-control" #validation name="validation">
                        <option>Rule for the field</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div><!--'CustomGridEditor'-->
              <div class="tab-content" *ngIf="palette.layoutCode === 'CustomGridEditor'">
                <div class="tab-pane container active" id="general" *ngIf="showTabs == 'general'">
                  <div class="p-fluid p-formgrid p-grid pt-2">
                    <!-- <div class="p-col-11 marginBtmLeft">
                                  <label class="label-cls mb-1">Title</label>
                                  <input type="text"name="label" [(ngModel)]="palette.label" />
                              </div> -->
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Unique Name of List</label>
                      <input type="text" name="label" [(ngModel)]="palette.name" />
                    </div>
                    <div class="p-col-11 marginBtmLeft">
                      <label class="label-cls mb-1">Data Field Name</label>
                      <input type="text" #dfName name="datafieldName" [(ngModel)]="palette.data_field_name" />
                    </div>
                  </div>
                  <p-fieldset [legend]="colProp.columnName" [toggleable]="true"
                    [collapsed]="palette.gridProperties.length!==i+1" class="m-2"
                    *ngFor="let colProp of palette.gridProperties; let i=index;">
                    <div class="p-fluid p-formgrid p-grid pt-2">
                      <div class="p-col-11 marginBtmLeft">
                        <label class="label-cls mb-1">Column Name</label>
                        <input type="text" name="label" [(ngModel)]="colProp.columnName" />
                      </div>
                      <div class="p-col-11 marginBtmLeft">
                        <label class="label-cls mb-1">Unique Name</label>
                        <input type="text" #uniqueName name="uniqueName" [(ngModel)]="colProp.columnDef" />
                      </div>
                      <div class="p-col-11 marginBtmLeft">
                        <label class="label-cls mb-1">Data Field Name</label>
                        <input type="text" #dfName name="datafieldName" [(ngModel)]="palette.data_field_name" />
                      </div>
                      <div class="p-col-11 marginBtmLeft">
                        <label class="label-cls mb-1">Column Type</label>
                        <select type="text" class="form-control" [(ngModel)]="colProp.columnType"
                          (change)="onChangeColType($event, palette)">
                          <option value="text">Text Field</option>
                          <option value="dropdown">Dropdown</option>
                          <option value="date">Date Field</option>
                          <option value="textarea">Text Area</option>
                          <option value="state">State / Province</option>
                          <option value="switch">Switch</option>
                          <!-- <option value="year">Year Field</option> -->
                        </select>
                      </div>
                      <div class="p-col-11 marginBtmLeft" *ngIf="colProp.columnType === 'switch'">
                        <label class="label-cls mb-1">Select Switch Type</label>
                        <select class="form-control" [(ngModel)]="colProp.columnOption" #refercenceCodeForApiCall
                          name="refercenceCodeForApiCall">
                          <option value="onoff">On / Off</option>
                          <option value="truefalse">True / False</option>
                          <option value="yesno">Yes / No</option>
                        </select>
                      </div>
                      <div class="p-col-11 marginBtmLeft"
                        *ngIf="colProp.columnType === 'dropdown' || colProp.columnType === 'state'">
                        <label class="label-cls mb-1"> Select the Data Source</label>
                        <select class="form-control" [(ngModel)]="colProp.columnOption" #refercenceCodeForApiCall
                          name="refercenceCodeForApiCall">
                          <option *ngFor="let item of dataSources" [value]="item.groupName">{{item.groupDesc}}</option>
                        </select>
                      </div>
                      <div class="p-col-11 marginBtmLeft"
                        *ngIf="colProp.columnType === 'dropdown' || colProp.columnType === 'state'">
                        <label class="label-cls mb-1"> Select the Data Dependency<small>(Optional)</small></label>
                        <input type="text" class="form-control" [(ngModel)]="colProp.dependency"
                          placeholder="Unique name of dependent field">
                      </div>
                      <div class="p-col-11 marginBtmLeft">
                        <label class="label-cls mb-1">Hide from list</label>
                        <p-checkbox class="ml-2" binary="false" name="hidefromcolumn" [(ngModel)]="colProp.hideFromList"
                          inputId="hidefromcolumn"></p-checkbox>
                      </div>
                    </div>
                  </p-fieldset>
                  <div class="p-col-11 marginBtmLeft palette_btn">
                    <button pButton pRipple type="button" label="Add More Column" title="Add More Column"
                      class="p-button-text p-button-plain" (click)="addMoreColumns()"></button>
                  </div>
                </div>
                <div class="tab-pane container active" id="optional" *ngIf="showTabs == 'optional'">
                  <div class="p-col-11 marginBtmLeft">
                    <label class="label-cls mb-1">Column Layout</label>
                    <select type="text" class="form-control" [(ngModel)]="palette.properties.colLayout"
                      (change)="onChangeColType($event, palette)">
                      <option value="col-12">col-1</option>
                      <option value="col-6">col-2</option>
                      <option value="col-4">col-3</option>
                      <!-- <option value="year">Year Field</option> -->
                    </select>
                  </div>
                </div>
                <div class="tab-pane container active" id="advanced" *ngIf="showTabs == 'advanced'">
                </div>
              </div>
              <!-- chip component -->
              <div class="tab-content" *ngIf="palette.layoutCode === 'CustomChipComponent'">
                <div class="tab-pane container active" id="general" *ngIf="showTabs == 'general'">
                  <div class="p-col-11 marginBtmLeft">
                    <label class="label-cls mb-1">Label Name</label>
                    <input type="text" name="label" [(ngModel)]="palette.label" />
                    <div class="indicatorRef">Label of the field</div>
                  </div>
                  <div class="p-col-11 marginBtmLeft">
                    <label class="label-cls mb-1">Sub Label</label>
                    <input type="text" name="label" [(ngModel)]="palette.subText" />
                    <div class="indicatorRef">Sub Label of the field</div>
                  </div>
                </div>
                <div class="tab-pane container active" id="optional" *ngIf="showTabs == 'optional'">
                  <div class="p-col-11 marginBtmLeft">
                    <label class="label-cls mb-1">Width of the Field</label>
                    <input type="text" name="label" [(ngModel)]="palette.style.width" />
                  </div>
                </div>
                <div class="tab-pane container active" id="advanced" *ngIf="showTabs == 'advanced'">
                  <div class="p-col-11 marginBtmLeft">
                    <label class="label-cls mb-1">Placeholder</label>
                    <input type="text" #placeholder name="placeholder" [(ngModel)]="palette.placeholder" />
                    <div class="indicatorRef">Add an example hint inside the field</div>
                  </div>
                  <div class="p-col-11 marginBtmLeft">
                    <label class="label-cls mb-1">Unique Name</label>
                    <input type="text" #uniqueName name="uniqueName" [(ngModel)]="palette.name" />
                  </div>
                  <div class="p-col-11 marginBtmLeft">
                    <label class="label-cls mb-1">Data Field Name</label>
                    <input type="text" #dfName name="datafieldName" [(ngModel)]="palette.data_field_name" />
                  </div>
                </div>
              </div>
              <!-- chip component -->
              <!-----Button Component-->
              <div class="p-fluid p-formgrid p-grid pt-2" *ngIf="palette.layoutCode === 'CustomButtonComponent'">
                <div class="p-col-11 marginBtmLeft">
                  <label class="label-cls mb-1">Label</label>
                  <input type="text" name="label" [(ngModel)]="palette.label" />
                  <div class="indicatorRef">Enter the Label </div>
                </div>
                <div class="p-col-11 marginBtmLeft">
                  <label class="label-cls mb-1">Action Type</label>
                  <select class="form-control" [(ngModel)]="palette.actionType">
                    <option>Select</option>
                    <option value="DS160">DS-160</option>
                    <option value="DS260">DS-260</option>
                    <option value="PERM">PERM</option>
                    <option value="PWD">PWD</option>
                    <option value="I130">I-130</option>
                    <option value="I129EFILING">I129EFILING</option>
                    <option value="N400EFILING">N400EFILING</option>
                    <option value="I190EFILING">I190EFILING</option>
                    <option value="I131EFILING">I131EFILING</option>
                    <option value="I765EFILING">I765EFILING</option>
                    <option value="I589EFILING">I589EFILING</option>
                    <option value="download">Download</option>
                  </select>
                </div>
                <div class="p-col-11 marginBtmLeft" *ngIf="palette.actionType === 'download'">
                  <label class="label-cls mb-1">Select Installer</label>
                  <select class="form-control" [(ngModel)]="palette.installerType">
                    <option>Select</option>
                    <option value="DS160">DS-160</option>
                    <option value="DS260">DS-260</option>
                    <option value="PERM">PERM</option>                    
                    <option value="PWD">PWD</option>
                    <option value="I130">I-130</option>
                    <option value="I129EFILING">I129EFILING</option>
                    <option value="N400EFILING">N400EFILING</option>
                    <option value="I190EFILING">I190EFILING</option>
                    <option value="I131EFILING">I131EFILING</option>
                    <option value="I765EFILING">I765EFILING</option>
                    <option value="I589EFILING">I589EFILING</option>
                  </select>                  
                </div>
                <div class="p-col-11 marginBtmLeft mt-1" *ngIf="palette.actionType && palette.actionType !== 'download'">
                  <input type="checkbox" [(ngModel)]="palette.allowDownloadAllFiles"
                          style="width:20px; height:20px; float:left" />
                        <span style="float:left; margin-left:10px">Allow download uploaded files?</span>
                </div>                
              </div>
              <!-----FormAction Button Component-->
              <div class="p-fluid p-formgrid p-grid pt-2" *ngIf="palette.layoutCode === 'CustomButtonActionComponent'">
                <div class="p-col-11 marginBtmLeft">
                  <label class="label-cls mb-1">Label</label>
                  <input type="text" name="label" [(ngModel)]="palette.label" />
                  <div class="indicatorRef">Enter the Label </div>
                </div>
                <div class="p-col-11 marginBtmLeft">
                  <label class="label-cls mb-1">Action Type</label>
                  <select type="text" class="form-control" [(ngModel)]="palette.actionType"
                    #actionType name="actionType">
                    <option *ngFor="let item of palette.properties.inputArray" [value]="item.url">{{item.name}}
                    </option>
                  </select>
                  <!-- <select class="form-control" [(ngModel)]="palette.actionType">
                    <option>Select</option>
                    <option value="beneficiaryProfile">Beneficiary Profile</option>
                  </select> -->
                </div>
              </div>
              <!---EO Button Component-->
              <div class="tab-content" *ngIf="prePDFToWorkflow === false && showTabs == 'general'">
                <div class="tab-pane container active">
                  <div class="p-fluid p-formgrid p-grid pt-2">
                    <div class="p-col-12 marginBtmLeft">
                      <p-inputSwitch [(ngModel)]="palette.isRowColumn" (onChange)="onRowColumnChange()"></p-inputSwitch>
                      <div class="indicatorRef">Enable Row & Column</div>
                    </div>
                    <ng-template [ngIf]="palette.isRowColumn">
                      <div class="p-col-12 marginBtmLeft">
                        <label class="label-cls mb-1 required">Row</label>
                        <p-inputNumber [useGrouping]="false" [(ngModel)]="palette.numberOfRow">
                        </p-inputNumber>
                      </div>
                      <div class="p-col-12 marginBtmLeft">
                        <label class="label-cls mb-1 required">Columns</label>
                        <p-dropdown appendTo="body" class="w-100" [options]="columnWidth"
                          [(ngModel)]="palette.numberOfColumn" optionValue="value" optionLabel="label">
                        </p-dropdown>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
              <div class="tab-content" *ngIf="showTabs == 'general'">
                <div class="tab-pane container active">
                  <div class="p-fluid p-formgrid p-grid pt-2">
                    <div class="p-col-12 marginBtmLeft">
                      <label class="label-cls mb-1 required">Top</label>
                      <p-inputNumber [useGrouping]="false" [(ngModel)]="palette.coordinateY">
                      </p-inputNumber>
                    </div>
                    <div class="p-col-12 marginBtmLeft">
                      <label class="label-cls mb-1 required">Left</label>
                      <p-inputNumber [useGrouping]="false" [(ngModel)]="palette.coordinateX">
                      </p-inputNumber>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </ng-template>
        </div>
        <div class="saveButton" *ngIf="prePDFToWorkflow && isEditVisa" (click)="saveSetting()">
          Save Field 
        </div>
        <div class="saveButton" *ngIf="prePDFToWorkflow === false && isEditVisa"
          [ngClass]="{'disabled': !((!palette.isRowColumn || (palette.isRowColumn && palette.numberOfRow && palette.numberOfColumn)) && palette.coordinateX !== null && palette.coordinateX !== undefined && palette.coordinateY !== null && palette.coordinateY !== undefined )}"
          (click)="(!palette.isRowColumn || (palette.isRowColumn && palette.numberOfRow && palette.numberOfColumn)) && palette.coordinateX !== null && palette.coordinateX !== undefined && palette.coordinateY !== null && palette.coordinateY !== undefined && saveSetting()">
          Save Field 
        </div>
        <div class="deleteButton" (click)="deleteField()" *ngIf="isEditVisa">
          Delete Field
        </div>


      </div>
      <div class="sidebar-listing mt-3">
        <div class="top_heading">
          <div class="sidebar-placeholder-title">Controls Added</div>
          <div class="sidebar-accordion-icon-holder">
            <a *ngIf="showFirstMenu" (click)="showFirstMenu = false;"
              class="pi pi-plus-circle sidebar-accordian-icon"></a>
            <a *ngIf="!showFirstMenu" (click)="showFirstMenu = true;"
              class="pi pi-minus-circle sidebar-accordian-icon"></a>
          </div>
        </div>
        <div class="sidebar-content" *ngIf="!showFirstMenu">
          <ng-template ngFor let-item [ngForOf]="htmlRenderObj" let-i="index">
            <div class="control-list clearfix" (mouseenter)="mouseEnter(item, i) " (mouseleave)="mouseLeave(item)"
              *ngIf="!item.emptyCol">
              <span class="control-name">
                {{ item.name }}
              </span>
              <a (click)="openPalette(i)" class="pi pi-pencil sidebar-accordian-icon"></a>
              <a (click)="removeBox(i, item.name)" class="pi pi-trash sidebar-accordian-icon"></a>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>


  <div [ngClass]="{'col-lg-12': user == true,'col-lg-9 float-right': user == false}">
    <div class="rightside-panel" id="dataPanel" #draggablecontainer>
      <div class="top_heading">
        <div class="col-md-8 text-left"><span>&#10094;</span><span (click)="hadleCancel()"
            class="noSpanBorder icn">Back</span> &nbsp;&nbsp;|&nbsp;&nbsp; Add/Edit required
          details</div>
        <button pButton pRipple type="button" label="Delete all" title="Delete all" icon="pi pi-trash"
          (click)="deleteAllControls()" *ngIf="resultObj && resultObj.length > 0 && customStepId && visaId"
          class="p-button-outlined p-button-rounded p-button-secondary create-step-delete-all-btn"></button>
        <div class="col-md-2 text-right pointer" (click)="isPreview=true;"><span>&#10094;</span>Preview</div>
      </div>
      <div class="pre-pdf-to-workflow-grid-system" *ngIf="prePDFToWorkflow">
        <div class="pb-4 mb-4 gridSystem" [formGroup]="addForm" cdkDragBoundary=".example-boundary">
          <div *ngFor="let _data of htmlRenderObj; let i = index;" cdkDrag class="vd-drag-box mainRepeatDragPanel"
            id={{i}} [ngClass]="{'leftAlign': _data.align == 'left', 'highlight-control': _data.hover}"
            (cdkDragEnded)="dragEnd($event, i, _data)"
            [style.transform]="'translate3d(' + _data.coordinateX + 'px, '+ _data.coordinateY + 'px, 0px)'">
            <div class="vd-heading-container">
              <div *ngIf="_data.style">
                <div class="labelHeading" [ngStyle]="_data.style.width" *ngIf="!labelNotNeededArray.includes(data.layoutCode)">{{_data.label}}</div>
              </div>
              <div class="labelHeading" *ngIf="_data.layoutCode === 'VdPhoneComponent'">{{_data.label}}</div>
              <div class="actionItems">
                <mat-icon class="crossIcon" (click)="openPalette(i)">edit</mat-icon>
                <mat-icon class="crossIcon" (click)="removeBox(i)">delete</mat-icon>
                <mat-icon class="crossIcon" draggable="true">drag_indicator</mat-icon>
              </div>
            </div>
            <div class="cords cordsTop">{{_data.coordinateY}}</div>
            <div class="cords cordsLeft">{{_data.coordinateX}}</div>
            <app-component-loader class="inlineblock" [rendercomponent]="_data.layoutCode" [sublabel]="_data.subText"
              [validation]="_data.mandatory" [readonly]="_data.readonly" [minLength]="_data.minLength"
              [maxLength]="_data.maxLength" [placeHolders]="_data.placeholder"
              [groupElementProperty]="_data.groupElementProperty" [visaType]="visaType"
              [typeOfButton]="_data.layoutCode ==='StepStatusUpdateComponentLibraryComponent' && _data.label === 'Edit' ? 'EDIT' : 'MARK_COMPLETE'"
              [formControlName]="_data.name" [group]="addForm" [groupName]="_data.groupName"
              [inputParams]="_data"></app-component-loader>
          </div>
        </div>
      </div>
      <div class="post-pdf-to-workflow-grid-system" *ngIf="prePDFToWorkflow === false">
        <div class="gridSystem clearfix" [formGroup]="addForm">
          <ng-template ngFor let-data [ngForOf]="htmlRenderObj" let-i="index">
            <div *ngIf="!data.emptyCol" cdkDrag class="vd-drag-box" id={{i}}
              [ngClass]="{'leftAlign': data.align == 'left', 'col-4': data.numberOfColumn && data.numberOfColumn === 4, 'col-6': data.numberOfColumn && data.numberOfColumn === 6, 'col-8': data.numberOfColumn && data.numberOfColumn === 8, 'col-12': data.numberOfColumn && data.numberOfColumn === 12, 'vd-drag-box-padding': !data.numberOfColumn, 'highlight-control': data.hover}"
              (cdkDragEnded)="dragEnd($event, i, data)"
              [style.transform]="'translate3d(' + data.coordinateX + 'px, '+ data.coordinateY + 'px, 0px)'">
              <div class="vd-heading-container">
                <div *ngIf="data.style">
                  <div class="labelHeading" [ngStyle]="data.style.width" *ngIf="!labelNotNeededArray.includes(data.layoutCode)">{{data.label}}</div>
                </div>
                <div class="labelHeading" *ngIf="data.layoutCode === 'VdPhoneComponent'">
                  {{data.label}}
                </div>
                <div class="actionItems">
                  <mat-icon class="crossIcon" (click)="openPalette(i)">edit</mat-icon>
                  <mat-icon class="crossIcon" (click)="removeBox(i)">delete</mat-icon>
                  <mat-icon class="crossIcon" draggable="true">drag_indicator</mat-icon>
                </div>
              </div>
              <div class="cords cordsLeft">{{data.coordinateX}}</div>
              <div class="cords-top-new">
                <div class="cords cordsTop">{{data.coordinateY}}</div>
                <div class="cords cordsTop" *ngIf="data.numberOfRow">R: {{data.numberOfRow}}</div>
                <div class="cords cordsTop" *ngIf="data.numberOfColumn">C: {{data.numberOfColumn === 12 ? 'Full' :
                  data.numberOfColumn === 6 ? 'Half' : data.numberOfColumn === 8 ? 'Two-third': 'One-third'}}</div>
              </div>
              <div class="alignmentFixes">
                <app-component-loader class="inlineblock" [rendercomponent]="data.layoutCode" [sublabel]="data.subText"
                  [validation]="data.mandatory" [readonly]="data.readonly" [minLength]="data.minLength"
                  [maxLength]="data.maxLength" [placeHolders]="data.placeholder"
                  [groupElementProperty]="data.groupElementProperty"
                  [typeOfButton]="data.layoutCode ==='StepStatusUpdateComponentLibraryComponent' && data.label === 'Edit' ? 'EDIT' : 'MARK_COMPLETE'"
                  [formControlName]="data.name" [group]="addForm" [groupName]="data.groupName" [inputParams]="data"
                  [visaType]="visaType"></app-component-loader>
              </div>
            </div>
            <div *ngIf="data.emptyCol" class="clearfix"></div>
          </ng-template>
        </div>
      </div>
      <br><br>
    </div>
    <div class="clearfix"></div>
    <p-divider type="dashed"></p-divider>
    <div class="row">
      <div class="buttonContainer float-right">
        <div> <button type="button" class="btn vdCancelBtn mr-3" (click)="hadleCancel()">CANCEL</button></div>
        <div> <button type="submit" class="btn vdCreateBtn mr-3" (click)="onSubmit('event')"
            [disabled]="htmlRenderObj?.length == 0">NEXT</button></div>
      </div>
    </div>
  </div>
</div>
<div class="row mb-4" *ngIf="isPreview">
  <div class="col-12 rightside-panel right-panel pointer">
    <div class="top_heading">
      <div class="col-md-10" (click)="isPreview=false;"><span>&#10095;</span>Preview Form</div>
      <!-- <div class="col-md-2 text-right" (click)="isPreview=false;"><span>&#10094;</span>Back</div> -->
    </div>
    <app-vd-steps-form-preview [htmlRenderObj]="htmlRenderObj"></app-vd-steps-form-preview>
  </div>
</div>
<p-confirmDialog header="Delete"></p-confirmDialog>